<idp-book-widget-search-modal
  [recentSearchList]="recentSearchList"
  [savedSearchList]="savedSearchList"
  [searchModalTabs]="searchModalTabs"
  [predictiveSearchData]="predictiveSearchData"
  [isFullscreen]="isFullscreen"
  [modalOpen]="modalOpen"
  (searchModalClose)="handleSearchModalClose($event)"
  (selectedTabChange)="handleModalEvents({ type: 'tabChange', data: $event })"
  (searchStringChanged)="
    handleModalEvents({ type: 'searchStringChanged', data: $event })
  "
  (savedSearchItemSelected)="
    handleModalEvents({ type: 'saveSearchItemSelected', data: $event })
  "
  (recentSearchItemSelected)="
    handleModalEvents({ type: 'recentSearchItemSelected', data: $event })
  "
  (predictiveSearchItemSelected)="handlePredictiveSearchItemselection($event)"
>
  <div
    class="idp-connection-picker__container"
    [class.idp-connection-picker__container_error]="!!errorMessage"
    [idpErrorState]="!!errorMessage"
    (click)="handleSearchModalTrigger()"
  >
    <div class="connection-airport-actions">
      <img
        class="connection-airport-tooltip"
        src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
        [attr.aria-label]="placeholder + ' ' + helpIconAriaLabel"
        role="button"
        tabindex="0"
        (click)="showConnectionAirportInfoModalHandler($event)"
        (keypress)="
          $event.key === 'Enter' &&
            showConnectionAirportInfoModalHandler($event)
        "
      />
      <img
        *ngIf="connection.connectionAirport"
        role="button"
        tabindex="0"
        class="connection-airport-remove-icon"
        src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/close.svg"
        (click)="clearConnectionAirportHandler($event)"
        (keypress)="
          $event.key === 'Enter' && clearConnectionAirportHandler($event)
        "
      />
    </div>
    <div class="connection-airport-text-section">
      <small
        *ngIf="connection.connectionAirport"
        class="idp-connection-picker__title"
        [class.idp-connection-picker__title_error]="!!errorMessage"
      >
        {{ placeholder }}
      </small>
      <span
        class="idp-connection-picker__input_text"
        [class.idp-connection-picker__input_text_with_title]="
          !!connection.connectionAirport
        "
        (click)="handleSearchModalTrigger()"
      >
        {{ connection.connectionAirport || placeholder }}
      </span>
    </div>
  </div>
  <ng-container *ngIf="errorMessage">
    <span class="idp-connection-picker__error-message">
      {{ errorMessage }}
    </span>
  </ng-container>
</idp-book-widget-search-modal>
